import moment from 'moment';

// All Events
export const ALL_EVENT_FILTERS = {
  endOn: undefined,
  deleted: undefined,
  sortBy: { startOn: 1 } // Sort in ascending order
};

// Active Events
export const UPCOMING_EVENT_FILTERS = {
  endOn: { $gt: moment().hour(0).minute(0).subtract(7, 'days').valueOf() },
  deleted: false,
  sortBy: { startOn: 1 } // Sort in ascending order
};

// Recent Events
export const RECENT_EVENT_FILTERS = {
  endOn: {
    $gt: moment().hour(0).minute(0).subtract(14, 'days').valueOf(),
    $lte: moment().hour(0).minute(0).subtract(12, 'hours').valueOf()
  },
  deleted: false,
  sortBy: { startOn: -1 } // Sort in descending order
};

// Past Events
export const PAST_EVENT_FILTERS = {
  endOn: { $lte: moment().hour(0).minute(0).subtract(7, 'days').valueOf() },
  deleted: false,
  sortBy: { startOn: -1 } // Sort in descending order
};

// Archived Events
export const ARCHIVED_EVENT_FILTERS = {
  endOn: { $lte: moment().hour(0).minute(0).subtract(7, 'days').valueOf() },
  deleted: undefined,
  archived: true,
  sortBy: { startOn: -1 } // Sort in descending order
};

export default {
  ALL_EVENT_FILTERS,
  UPCOMING_EVENT_FILTERS,
  PAST_EVENT_FILTERS,
  RECENT_EVENT_FILTERS,
  ARCHIVED_EVENT_FILTERS
};
